import { render } from "./BankBookIndex.vue?vue&type=template&id=11449808&scoped=true"
import script from "./BankBookIndex.vue?vue&type=script&lang=js"
export * from "./BankBookIndex.vue?vue&type=script&lang=js"

import "./BankBookIndex.vue?vue&type=style&index=0&id=11449808&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11449808"]])

export default __exports__